import { supabase } from './supabase';

export async function isProjectOwner(projectId: string): Promise<boolean> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return false;

    // First check if user is the owner
    const { data: project } = await supabase
      .from('interview_projects')
      .select('owner_id')
      .eq('id', projectId)
      .single();

    if (project?.owner_id === user.id) {
      return true;
    }

    // If not owner, check if user is an editor
    const { data: editor } = await supabase
      .from('project_editors')
      .select('user_id')
      .eq('project_id', projectId)
      .eq('user_id', user.id)
      .single();

    return !!editor;
  } catch (error) {
    console.error('Error checking project permissions:', error);
    return false;
  }
}